export const logoNegative = []
